import TeamStatsLayout from 'layouts/team-stats.layout';
import React from 'react';
import Slider from 'react-slick';
import KitchenStatsPageOne from './kitchen-stats-page-one';
// import KitchenStatsPageTwo from './kitchen-stats-page-two';
// import KitchenStatsPageEight from './kitchen-stats-page-eight';
import KitchenStatsPageSeven from './kitchen-stats-page-seven';
import KitchenStatsPageThree from './kitchen-stats-page-three';
// import KitchenStatsPageFive from './kitchen-stats-page-five';
// import KitchenStatsPageFour from './kitchen-stats-page-four';
// import KitchenStatsPageNine from './kitchen-stats-page-nine';
import KitchenStatsPageTen from './kitchen-stats-page-ten';
import KitchenShiftStats from './kitchen-shifts-stats';

const KitchenTeamStats = () => {
  const Settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    slickPlay: true,
    autoplaySpeed: 5000
  };

  return (
    <TeamStatsLayout>
      <Slider {...Settings} className='stats_slider'>
        <div className='max-w-screen'>
          <KitchenStatsPageOne />
        </div>
        <div className='max-w-screen'>
          <KitchenShiftStats />
        </div>
        {/* <div className='max-w-screen'>
          <KitchenStatsPageTwo />
        </div> */}
        <div className='max-w-screen'>
          <KitchenStatsPageThree />
        </div>
        {/* <div className='max-w-screen'>
          <KitchenStatsPageFour />
        </div> */}
        {/* <div className='max-w-screen'>
          <KitchenStatsPageFive />
        </div> */}
        <div className='max-w-screen'>
          <KitchenStatsPageSeven />
        </div>
        {/* <div className='max-w-screen'>
          <KitchenStatsPageNine />
        </div> */}
        {/* <div className='max-w-screen'>
          <KitchenStatsPageEight />
        </div> */}
        <div className='max-w-screen'>
          <KitchenStatsPageTen />
        </div>
      </Slider>
    </TeamStatsLayout>
  );
};
export default KitchenTeamStats;
